import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '../types';

interface AuthState {
  token: string | null;
  user: User | null;
  isDemo: boolean;
  setAuth: (token: string, user: User, demo?: boolean) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
  hasRole: (role: string) => boolean;
}

export const DEMO_USER: User = {
  id: 0,
  email: 'demo@printErp.es',
  name: 'Usuario Demo',
  avatar: undefined,
  roles: ['ROLE_ADMIN', 'ROLE_GESTOR', 'ROLE_FINANCIERO', 'ROLE_IMPRENTA', 'ROLE_DTF', 'ROLE_ALMACEN', 'ROLE_EMBALAJE'],
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isDemo: false,
      setAuth: (token, user, demo = false) => set({ token, user, isDemo: demo }),
      logout: () => set({ token: null, user: null, isDemo: false }),
      isAuthenticated: () => !!get().token,
      hasRole: (role) => get().user?.roles?.includes(role as any) ?? false,
    }),
    { name: 'erp-auth' }
  )
);
